import {Injectable} from "@angular/core";
import { HttpClient } from "@angular/common/http";
import {firstValueFrom} from "rxjs";
import {EmailProviderRouting} from "./email-provider-routing.type";

@Injectable()
export class EmailProviderRoutingService {

    constructor(private http: HttpClient){}
    async get(): Promise<EmailProviderRouting> {
        return await firstValueFrom(this.http.get<EmailProviderRouting>(`/admin/emailproviderrouting/`));
    }

    async update(routing: EmailProviderRouting): Promise<EmailProviderRouting> {
        return await firstValueFrom(this.http.post<EmailProviderRouting>('/admin/emailproviderrouting/', routing));
    }
}